export const DISPATCH_TIME = "Dispatch Time"
export const ROUTE_ID = "Route ID"
export const LOCATION = "Location"
export const STATUS = "Status"
export const PROGRESS = "Progress"
export const DRIVER = "Driver"
export const ROUTE_TYPE = "Type"
export const DEPART_TIME = "Depart Time"
export const SECTORS = "Sectors"
export const DEPART_TABLE_COLUMNS = [
    DISPATCH_TIME,
    ROUTE_ID,
    LOCATION,
    STATUS,
    PROGRESS,
    ROUTE_TYPE,
    DRIVER,
    DEPART_TIME
]

export const DEPART_TABLE_COLUMNS_IN = [
    DISPATCH_TIME,
    ROUTE_ID,
    SECTORS,
    STATUS,
    PROGRESS,
    ROUTE_TYPE,
    DRIVER,
    DEPART_TIME
]


// WEBPACK FOOTER //
// ./src/components/depart/DepartTableColumns.js